import { Box, TableContainer } from '@mui/material'
import * as React from 'react'
import { Navigate, useSearchParams } from 'react-router-dom'
import { DataGridPro } from '@mui/x-data-grid-pro'
//import { useLocalStorage } from '@uidotdev/usehooks' //FIXME: https://github.com/uidotdev/usehooks/issues/264
import { useLocalStorage } from 'usehooks-ts'
import PageSection from '../../../Constants&Theme/PageSection'
import { useStudyGet } from '../../../APIs/Hooks/StudyHooks'
import { useStudySelectDGCols } from './StudySelectDGCols'
import { useGetProtocolName } from '../StudyFns'
import { StudySelectToolbar } from './StudySelectToolbar'
import { appBar } from '../../../garvan-react/Constants/StyleConstants'

function StudySelect() {
  const [searchParams] = useSearchParams()
  const protocol_id = searchParams.get('protocol_id')
  const [statusFilter, setStatusFilter] = useLocalStorage(
    'studyStatusFilter',
    'ACT',
  )
  const studyListQuery = useStudyGet(
    `?protocol_id=${protocol_id}&status=${statusFilter}`,
    !!protocol_id,
  )
  const protocolName = useGetProtocolName(protocol_id)
  const cols = useStudySelectDGCols(statusFilter)

  if (!protocol_id) {
    return (
      <Navigate
        to={'Protocols'}
        replace
      />
    )
  }
  return (
    <Box
      sx={{
        maxWidth: 'md',
        width: 1,
      }}
    >
      <PageSection title={'Studies: ' + protocolName}>
        <StudySelectToolbar
          studyListQuery={studyListQuery}
          protocol_id={protocol_id}
          statusFilter={statusFilter}
          setStatusFilter={setStatusFilter}
        />
        <TableContainer
          sx={{ height: `calc(100vh - ${appBar}px - 300px)`, width: 1 }}
        >
          <DataGridPro
            rows={studyListQuery?.data ?? []}
            getRowId={(row) => row.StudyID}
            columns={cols}
            loading={studyListQuery?.isLoading}
            disableColumnMenu
          />
        </TableContainer>
      </PageSection>
    </Box>
  )
}

export default StudySelect
